module.exports = __webpack_public_path__ + "static/media/costcontrol2.87fd6772.png";